import { ReactElement, SVGProps } from 'react'
export const SvgMenu = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M23.063 11.063H.938a.937.937 0 1 0 0 1.874h22.125a.937.937 0 1 0 0-1.874Zm0-7.5H.938a.937.937 0 1 0 0 1.874h22.125a.937.937 0 1 0 0-1.875Zm0 15H.938a.937.937 0 1 0 0 1.875h22.125a.937.937 0 1 0 0-1.875Z"
    />
  </svg>
)
